export const TOKEN_KEY = 'q4udoc.admin.token';
export const REFRESH_KEY = 'q4udoc.admin.refreshToken';
export const EXPIRY_KEY = 'q4udoc.admin.tokenExpiry';
export const API_URL = '/api/admin';
export const CONFIG_URL = '/api/admin/config';
